import React, {
  useMemo,
  useState,
  useCallback,
  useEffect,
  useContext,
} from 'react';
import { useRouteMatch } from 'react-router-dom';

import useNavigation from '../../../hooks/useNavigation';
import AnnouncementContext from '../../context/AnnouncementContext';
import {
  AnnouncementsManagerTab,
  announcementsManagerPagesConfig,
  getTabPath,
} from '../../routes/announcementsManager/announcementsManagerPages';

import { Container, Header, StyledTabs } from './styles';
import { AnnouncementsManagerTabsConfig } from './utils';

const AnnouncementsManagerDashboard = () => {
  const { navigateTo } = useNavigation();
  const match = useRouteMatch();
  const { notificationCount } = useContext(AnnouncementContext);

  const [selectedTab, setSelectedTab] = useState(AnnouncementsManagerTab.POSTS);

  const onSelectedTab = useCallback(
    (tabSelected) => {
      navigateTo(getTabPath(tabSelected), { clearSearch: true });
    },
    [navigateTo],
  );

  const tabsConfigs = Object.keys(AnnouncementsManagerTabsConfig).reduce((acc, tab) => {
    acc[tab] = {
      ...AnnouncementsManagerTabsConfig[tab],
      ...((tab === AnnouncementsManagerTab.NOTIFICATIONS || tab === AnnouncementsManagerTab.REPORTS)
        && { count: notificationCount[tab] }),
    };
    return acc;
  }, {});

  useEffect(() => {
    // Get the last part of the pathname to detect if it is a valid announcements manager tab.
    const currentAnnouncementsManagerTab = match.path.split('/').pop();

    // Get the config object from the path we extracted from the url
    const tabConfig = Object.values(announcementsManagerPagesConfig).find(
      ({ path }) => path === currentAnnouncementsManagerTab,
    );

    if (tabConfig) {
      setSelectedTab(tabConfig.id);
    }
  }, [match]);

  const tabContent = useMemo(() => {
    const { component: TabContent } = AnnouncementsManagerTabsConfig[selectedTab];
    return <TabContent />;
  }, [selectedTab]);

  return (
    <Container>
      <Header>
        <StyledTabs
          tabsConfig={tabsConfigs}
          selectedTab={selectedTab}
          onSelectTab={onSelectedTab}
        />
      </Header>
      {tabContent}
    </Container>
  );
};

export default AnnouncementsManagerDashboard;
